import { mode } from '@chakra-ui/theme-tools';

const tableVariant = (props) => ({
  th: {
    color: mode('gray.500', 'gray.400')(props),
    borderColor: mode('gray.200', 'whiteAlpha.200')(props),
  },
  td: {
    color: mode('secondaryGray.900', 'whiteAlpha.900')(props),
    borderColor: mode('gray.200', 'whiteAlpha.100')(props),
  },
});

export const surfaceStyles = {
  components: {
    Table: {
      variants: {
        simple: tableVariant,
        striped: (props) => ({
          ...tableVariant(props),
          tbody: {
            tr: {
              '&:nth-of-type(odd)': {
                td: {
                  bg: mode('gray.50', 'navy.700')(props),
                },
              },
            },
          },
        }),
      },
    },
    Modal: {
      baseStyle: (props) => ({
        dialog: {
          bg: mode('white', 'navy.800')(props),
          color: mode('secondaryGray.900', 'white')(props),
        },
        header: {
          color: mode('secondaryGray.900', 'white')(props),
        },
        body: {
          color: mode('secondaryGray.900', 'whiteAlpha.900')(props),
        },
        footer: {
          borderTopColor: mode('gray.200', 'whiteAlpha.200')(props),
        },
        closeButton: {
          color: mode('gray.500', 'whiteAlpha.700')(props),
          _hover: {
            bg: mode('blackAlpha.100', 'whiteAlpha.200')(props),
          },
        },
      }),
    },
    Drawer: {
      baseStyle: (props) => ({
        dialog: {
          bg: mode('white', 'navy.800')(props),
          color: mode('secondaryGray.900', 'white')(props),
        },
        header: {
          color: mode('secondaryGray.900', 'white')(props),
          borderBottomColor: mode('gray.200', 'whiteAlpha.200')(props),
        },
        body: {
          color: mode('secondaryGray.900', 'whiteAlpha.900')(props),
        },
        footer: {
          borderTopColor: mode('gray.200', 'whiteAlpha.200')(props),
        },
        closeButton: {
          color: mode('gray.500', 'whiteAlpha.700')(props),
        },
      }),
    },
    Popover: {
      baseStyle: (props) => ({
        content: {
          bg: mode('white', 'navy.800')(props),
          borderColor: mode('gray.200', 'whiteAlpha.200')(props),
          color: mode('secondaryGray.900', 'white')(props),
          boxShadow: mode('lg', 'dark-lg')(props),
        },
        header: {
          color: mode('secondaryGray.900', 'white')(props),
        },
        body: {
          color: mode('secondaryGray.900', 'whiteAlpha.900')(props),
        },
      }),
    },
    Menu: {
      baseStyle: (props) => ({
        list: {
          bg: mode('white', 'navy.800')(props),
          borderColor: mode('gray.200', 'whiteAlpha.200')(props),
          boxShadow: mode('lg', 'dark-lg')(props),
        },
        item: {
          bg: mode('white', 'navy.800')(props),
          color: mode('secondaryGray.900', 'white')(props),
          _hover: {
            bg: mode('gray.50', 'navy.600')(props),
            color: mode('secondaryGray.900', 'white')(props),
          },
          _focus: {
            bg: mode('gray.50', 'navy.600')(props),
            color: mode('secondaryGray.900', 'white')(props),
          },
        },
      }),
    },
    Divider: {
      baseStyle: (props) => ({
        borderColor: mode('gray.200', 'whiteAlpha.200')(props),
      }),
    },
    Tooltip: {
      baseStyle: (props) => ({
        bg: mode('navy.700', 'gray.700')(props),
        color: 'white',
      }),
    },
  },
};
